var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.869216 5.369C0.925718 5.311 1.13906 5.063 1.3378 4.859C2.50292 3.576 5.54238 1.476 7.13322 0.835C7.37482 0.732 7.98563 0.514 8.31198 0.5C8.6247 0.5 8.9228 0.572 9.20726 0.718C9.56186 0.922 9.84632 1.243 10.0022 1.622C10.1025 1.885 10.2584 2.672 10.2584 2.686C10.4143 3.547 10.5 4.946 10.5 6.492C10.5 7.965 10.4143 9.307 10.2867 10.181C10.272 10.195 10.1162 11.173 9.94569 11.508C9.63298 12.12 9.02216 12.5 8.36848 12.5H8.31198C7.88626 12.485 6.99099 12.105 6.99099 12.091C5.48587 11.449 2.51656 9.452 1.32319 8.125C1.32319 8.125 0.987092 7.784 0.840964 7.571C0.613005 7.265 0.5 6.886 0.5 6.507C0.5 6.084 0.627618 5.69 0.869216 5.369Z",
    fill: "url(#paint0_linear_1680_1164)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1680_1164",
    x1: 5.5,
    y1: 0.5,
    x2: 5.5,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#917AFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#917AFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.c1ab3e70b8c27e491526fe3d24681220.svg";
export { ForwardRef as ReactComponent };